.header {
    background-color: #272333;
    padding: 0.25rem 2rem;
    /* filter: drop-shadow(2px 3px 3px #55555599); */
    display: flex;
    z-index: 999;
    max-height: 4rem;
    align-items: center;
  }
  
  .headerLogo {
    background: url(../../../images/rtk_logo_small_white.gif) no-repeat;
    height: 45px;
    width: 90%;
    margin: 12px auto;
    background-size: 140px;
    background-position: center;
  }

  .menuIcon {
    cursor: pointer;
  }
  